import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import index from '@/components/index'
import indexSub from '@/components/subPage/indexSub'
import physicalExamination from '@/components/subPage/physicalExamination'
import touchLimit from '@/components/subPage/touchLimit.vue'
import chemistryTouchLimit from '@/components/subPage/chemistryTouchLimit.vue'
import ultraHighRadiationTouch from '@/components/subPage/ultraHighRadiationTouch.vue'
import highFrequencyElectromagnetic from '@/components/subPage/highFrequencyElectromagnetic.vue'
import powerFrequencyElectric from '@/components/subPage/powerFrequencyElectric.vue'
import eyeLaser from '@/components/subPage/eyeLaser.vue'
import laserIrradiation from '@/components/subPage/laserIrradiation.vue'
import microwave from '@/components/subPage/microwave.vue'
import ultravioletRadiation from '@/components/subPage/ultravioletRadiation.vue'
import labourIntensity from '@/components/subPage/labourIntensity.vue'
import noise from '@/components/subPage/noise.vue'
import impulseNoise from '@/components/subPage/impulseNoise.vue'
import handBorneVibration from '@/components/subPage/handBorneVibration.vue'
import excavation from '@/components/subPage/excavation.vue'
import dustTouchLimit from '@/components/subPage/dustTouchLimit.vue'
import biologicalTouchLimit from '@/components/subPage/biologicalTouchLimit.vue'
import noiseLevelCompute from '@/components/subPage/noiseLevelCompute.vue'
import scanImgToExcel from '@/components/subPage/scanImgToExcel.vue'
import riskLevel from '@/components/subPage/riskLevel/riskLevel.vue'
import regulations from '@/components/subPage/regulations.vue'
import Detail from '@/components/subPage/Detail.vue'
import warnSignGenerate from '@/components/subPage/warnSignGenerate.vue'
import top from '@/components/subComponents/top.vue'
import logindemo from '@/components/subPage/logindemo.vue'
import ppmConversion from '@/components/subPage/ppmConversion.vue'



Vue.use(Router)

export default new Router({
  routes: [
//     { path: '/',
//     name: 'logindemo',
//     component: logindemo,
// },
    {
    path: '/',
    name: 'index',
    component: index,
    redirect: '/indexSub',

    children: [{
        path: '/indexSub',
        name: 'indexSub',
        component: indexSub,
      },
      {
        path: 'physicalExamination/:sort',
        name: 'physicalExamination',
        component: physicalExamination,
      },
      {
        path: 'regulations/:sort',
        name: 'regulations',
        meta:{
                keepAlive:true
              },
        component: regulations,

      },
      {
        path: 'regulations/:sort/detail',
        name: 'detail',
        component: Detail,

      },
      {
        path: 'riskLevel/:sort',
        name: 'riskLevel',
        component: riskLevel
      },
      {
        path: 'scanImgToExcel/:sort',
        name: 'scanImgToExcel',
        component: scanImgToExcel
      },
      {
        path: 'noiseLevelCompute/:sort',
        name: 'noiseLevelCompute',
        component: noiseLevelCompute
      },
      {
        path: 'touchLimit/:sort',
        name: 'touchLimit',
        component: touchLimit,
        redirect: 'touchLimit/:sort/chemistryTouchLimit',
        children: [{
            path: 'chemistryTouchLimit',
            name: 'chemistryTouchLimit',
            component: chemistryTouchLimit
          }, {
            path: 'dustTouchLimit',
            name: 'dustTouchLimit',
            component: dustTouchLimit
          }, {
            path: 'biologicalTouchLimit',
            name: 'biologicalTouchLimit',
            component: biologicalTouchLimit
          }, {
            path: 'ultraHighRadiationTouch',
            name: 'ultraHighRadiationTouch',
            component: ultraHighRadiationTouch
          },
          {
            path: 'highFrequencyElectromagnetic',
            name: 'highFrequencyElectromagnetic',
            component: highFrequencyElectromagnetic
          }, {
            path: 'powerFrequencyElectric',
            name: 'powerFrequencyElectric',
            component: powerFrequencyElectric
          },
          {
            path: 'eyeLaser',
            name: 'eyeLaser',
            component: eyeLaser
          }, {
            path: 'laserIrradiation',
            name: 'laserIrradiation',
            component: laserIrradiation
          },
          {
            path: 'microwave',
            name: 'microwave',
            component: microwave
          },
          {
            path: 'ultravioletRadiation',
            name: 'ultravioletRadiation',
            component: ultravioletRadiation
          },
          {
            path: 'labourIntensity',
            name: 'labourIntensity',
            component: labourIntensity
          },
          {
            path: 'noise',
            name: 'noise',
            component: noise
          },
          {
            path: 'impulseNoise',
            name: 'impulseNoise',
            component: impulseNoise
          },
          {
            path: 'handBorneVibration',
            name: 'handBorneVibration',
            component: handBorneVibration
          },
          {
            path: 'excavation',
            name: 'excavation',
            component: excavation
          },

        ]
      },
      {
        path: 'warnSignGenerate/:sort',
        name: 'warnSignGenerate',
        component: warnSignGenerate
      },
      {
        path: 'top',
        name: 'top',
        component: top
      },
      {
        path: 'logindemo',
        name: 'logindemo',
        component: logindemo
      },
      {
        path: 'ppmConversion/:sort',
        name: 'ppmConversion',
        component: ppmConversion
      },




    ]
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js